import AccountdashboardIcon from "./accountdashboard.svg";
import AccountplusIcon from "./accountplus.svg";
import AccountsettingIcon from "./accountsetting.svg";
import ActionsIcon from "./actions.svg";
import AgeCreamIcon from "./ageCream.svg";
import AgentIcon from "./agent.svg";
import AgentpageIcon from "./agentpage.svg";
import AgentsucessIcon from "./agentsucess.svg";
import AnalyticsIcon from "./analytics.svg";
import AvatarGirlIcon from "./avatar-girl.svg";
import AvatarIcon from "./avatar.svg";
import BluedownloadIcon from "./bluedownload.svg";
import BulbIcon from "./bulb.svg";
import BusinessIcon from "./business.svg";
import ChannelIcon from "./channel.svg";
import ChatbotIcon from "./chatbot.svg";
import ChatbotsecondIcon from "./chatbotsecond.svg";
import CheckinboxIcon from "./checkinbox.svg";
import CollaspLeftIcon from "./collaspLeft.svg";
import CollaspRightIcon from "./collaspRight.svg";
import ConcieLogoIcon from "./concie-logo.svg";
import ConciehalfIcon from "./conciehalf.svg";
import ConfulenceIcon from "./confulence.svg";
import ConnectIcon from "./connect.svg";
import CrossIcon from "./cross.svg";
import DeleteIcon from "./delete.svg";
import DownIcon from "./down.svg";
import EmptyIcon from "./empty.svg";
import EyeIcon from "./eye.svg";
import FacebookIcon from "./facebook.svg";
import FacialMaskIcon from "./facialMask.svg";
import FileExplorerIcon from "./FileExplorer.svg";
import FilesIcon from "./files.svg";
import FileuploadIcon from "./fileupload.svg";
import GoogleIcon from "./google.svg";
import GoogledriveIcon from "./googledrive.svg";
import HomeIcon from "./home.svg";
import Icon1Icon from "./icon1.svg";
import Icon2Icon from "./icon2.svg";
import Icon3Icon from "./icon3.svg";
import Icon4Icon from "./icon4.svg";
import InboxIcon from "./inbox.svg";
import InstagramIcon from "./instagram.svg";
import IntegrationIcon from "./integration.svg";
import InteractionIcon from "./interaction.svg";
import LearningIcon from "./learning.svg";
import LimitIcon from "./limit.svg";
import LinkedinIcon from "./linkedin.svg";
import LoginImgIcon from "./LoginImg.svg";
import LogoIcon from "./logo.svg";
import MacosIcon from "./macos.svg";
import MailIcon from "./mail.svg";
import MicIcon from "./mic.svg";
import MoreVerticalIcon from "./MoreVertical.svg";
import MoveDownIcon from "./moveDown.svg";
import NotificationIcon from "./notification.svg";
import NotionIcon from "./notion.svg";
import OnedriveIcon from "./onedrive.svg";
import PinterestIcon from "./pinterest.svg";
import RecordingIcon from "./recording.svg";
import Record from "./record.svg";
import RedCrossIcon from "./red-cross.svg";
import ReportIcon from "./report.svg";
import RolesIcon from "./roles.svg";
import SalesforceIcon from "./salesforce.svg";
import ScenariosIcon from "./scenarios.svg";
import SendIcon from "./send.svg";
import SettingIcon from "./setting.svg";
import SideBarHomeIcon from "./sideBarHome.svg";
import SignoutIcon from "./signout.svg";
import SocialIcon from "./social.svg";
import SourceIcon from "./source.svg";
import TaskIcon from "./task.svg";
import TempsignupimgIcon from "./tempsignupimg.svg";
import TextIcon from "./text.svg";
import TrainingIcon from "./training.svg";
import TwitterIcon from "./twitter.svg";
import UploadIcon from "./upload.svg";
import UserIcon from "./user.svg";
import VoiceIcon from "./voice.svg";
import WebIcon from "./web.svg";
import WebsiteIcon from "./website.svg";
import WorkspacedownIcon from "./workspacedown.svg";
import ViewPaper from "./view-paper.svg";
import FontIcon from "./font.svg";
import TxtIcon from "./txt.svg";
import PdfIcon from "./pdf.svg";
import WordIcon from "./word.svg";
import ContactIcon from "./contact.svg";
import FoldedPaper from "./folded-paper.svg";
import GlobeIcon from "./globe.svg";
import TripleDotIcon from "./tripleDot.svg";
import UserStarIcon from "./userStar.svg";
import WavesIcon from "./waves.svg";
import DashMeterIcon from "./dashMeter.svg";
import ParallelArrowsIcon from "./parallelArrows.svg";
import TopRightArrowIcon from "./topRightArrow.svg";
import GearInArrowCircleIcon from "./gearInArrowCircle.svg";
import HappyFaceIcon from "./happyface.svg";
import SadFaceIcon from "./sadface.svg";
import NeutralFaceIcon from "./neutralface.svg";
import ThumbsUpIcon from "./thumbs-up.svg";
import ThumbsDownIcon from "./thumbs-down.svg";
import FilledThumbsUpIcon from "./filled-thumbs-up.svg";
import FilledThumbsDownIcon from "./filled-thumbs-down.svg";
import CompassIcon from "./compass.svg";
import CopyWhiteIcon from "./copy-white.svg";
import GreenContactIcon from "./green-contact.svg";
import CheckForm from "./check-form.svg";
import CopyIcon from "./copy.svg";
import PurpleMessage from "./purple-message.svg";
import BlueMessage from "./blue-message.svg";
import OrangeMessage from "./orange-message.svg";
import GreenMessage from "./green-message.svg";
import InvertCopyIcon from "./invert-copy.svg";
import MessageIcon from "./message.svg";
import AdvancedIcon from "./hexagon.svg";
import ThreadsIcon from "./threads.svg";
import WixLogoIcon from "./WixLogo.svg";
import ShopifyLogo from "./ShopifyLogo.svg";
import FramerLogo from "./FramerLogo.svg";
import WordPressLogo from "./WordpressLogo.svg";
import WebflowIcon from "./webflowLogo.svg";
import ContactFormIcon from "../forms/contact.svg";
import BookingIcon from "../forms/booking.svg";
import CallIcon from "../forms/call.svg";
import CartIcon from "../forms/cart.svg";
import ConsentIcon from "../forms/consent.svg";
import DiscountIcon from "../forms/discount.svg";
import InternetIcon from "../forms/internet.svg";
import OrderIcon from "../forms/order.svg";
import QuoteIcon from "../forms/quote.svg";
import ReviewIcon from "../forms/review.svg";
import SupportIcon from "../forms/support.svg";
import Alien from "./alien.svg";
import SendArrow from "./send-arrow.svg";
import ShopifyIcon from "../apps/shopify.svg";
import OutlookIcon from "../apps/outlook.svg";
import HubspotIcon from "../apps/hubspot.svg";
import CalendlyIcon from "../apps/calendly.svg";
import WixIcon from "../apps/wix.svg";
import ZendeskIcon from "../apps/zendesk.svg";
import ApolloIcon from "../apps/apollo.svg";
import ZapierIcon from "../apps/zapier.svg";
import WooCommerceIcon from "../apps/woo.svg";
import FreshdeskIcon from "../apps/freshdesk.svg";
import GoogleTagManagerIcon from "../apps/googleTagManager.svg";
import ArrowIcon from "./arrow.svg";
import TVIcon from "./tv.svg";
import RoundContactIcon from "./round-contact.svg";
import ChannelWebsiteIcon from "./channelWebsite.svg";
import SharedIcon from "./shared.svg";
import MultiUserIcon from "./multiUser.svg";
import MessageIconWhite from "./messagewhite.svg";
import NutBotlIcon from "./bolt.svg";
import StatsIcon from "./stats.svg";
import PromptIcon from "./prompt.svg";
import ShieldIcon from "./shield.svg";
import QuestionMarkIcon from "./questionmark.svg";
import BlackQuestion from "./blackquestion.svg";
import TrashIcon from "./trash.svg";
import QuestionIcon from "./question.svg";
import OfficialAvatar from "./officialavatar.svg";
import FilesBlueIcon from "./filesblue.svg";
import GlobeOrangeIcon from "./globeorange.svg";
import GlobeYellowIcon from "./globeyellow.svg";
import SocialPinkIcon from "./socialpink.svg";
import Analytics2Icon from "./analytics2.svg";
import SourcesIcon from "./sources.svg";
import Stats2Icon from "./stats2.svg";
import TIcon from "./t.svg";
import YoutubeIcon from "./youtube.svg";
import PictureIcon from "./picture.svg";
import PlacementIcon from "./presence.svg";
import PlanIcon from "./plan.svg";
import BillingIcon from "./bill.svg";
import MembersIcon from "./members.svg";
import GeneralIcon from "./generaldots.svg";
import MapIcon from "./mapIcon.svg";
import Featured from "./Featured.svg";
import Confetti from "./confetti.svg";
import Bookings from "./booking.svg";
import OutlookCalendarIcon from "./outlookcalendar.svg";
import SocialLikeIcon from "../forms/social.svg";
import Search from "../forms/search.svg";
import BookIcon from "../forms/book.svg";
import AssetsIcon from "../forms/assets.svg";
import TeamsIcon from "../forms/team.svg";
import HumanIcon from "../forms/human.svg";
import AppointmentIcon from "../forms/appointment.svg";
import RequestIcon from "../forms/requestinfo.svg";
import FacebookActivity from "./facebookActivity.svg";
import InstagramActivity from "./instagramActivity.svg";
import StandAloneActivity from "./standaloneactivity.svg";
import AssetVideo from "./assetvideo.svg";
import AssetImage from "./assetimage.svg";
import AssetPdf from "./assetpdf.svg";
import AssetList from "./Assetlist.svg";
import AssetMap from "./Assetmap.svg";
import AssetUrl from "./Assetlink.svg";
import GoogleCalendar from "./googlecalendar.svg";
import OutlookCalendar from "./outlookcalendar.svg";
import BellIcon from "./bellicon.svg";
import ShowAssets from "./showAssets.svg";
import AssetPreview from "./AssetPreview.svg";
import Addlink from "./link.svg";
import WhatsappActivity from "./whatsappActivity.svg"
import Frame from "./Frame.svg";
import Role from "./Role.svg";
import SettingTwoIcon from "./settingsTwo.svg";
import LimitationsIcon from "./limitations.svg";
import UserRulesIcon from "./userRules.svg";
import DragIcon from "./drage.svg";
import ConcieBlackIcon from "./concieBlack.svg"
import AIIcon from "./ai.svg";
import ActivityPreview from "./ActivityPreview.svg";
import UpArrow from './UpArrow.svg';
import Microphone from './Microphone.svg';
import OnboardingAvatar from './OnboardingAvatar.svg';
import StarsIcon from './stars.png'
import Magical3 from "./Magical3.svg";

export {
  Record,
  Magical3,
  ActivityPreview,
  AIIcon,
  Featured,
  Confetti,
  PlanIcon,
  BillingIcon,
  MembersIcon,
  GeneralIcon,
  PlacementIcon,
  TIcon,
  YoutubeIcon,
  PictureIcon,
  Analytics2Icon,
  SourcesIcon,
  Stats2Icon,
  FilesBlueIcon,
  GlobeOrangeIcon,
  GlobeYellowIcon,
  SocialPinkIcon,
  OfficialAvatar,
  QuestionIcon,
  TrashIcon,
  BlackQuestion,
  QuestionMarkIcon,
  AccountdashboardIcon,
  AccountplusIcon,
  AccountsettingIcon,
  ActionsIcon,
  AgeCreamIcon,
  AgentIcon,
  AgentpageIcon,
  AgentsucessIcon,
  AnalyticsIcon,
  AvatarGirlIcon,
  AvatarIcon,
  BluedownloadIcon,
  BulbIcon,
  BusinessIcon,
  ChannelIcon,
  ChatbotIcon,
  ChatbotsecondIcon,
  CheckinboxIcon,
  CollaspLeftIcon,
  CollaspRightIcon,
  ConcieLogoIcon,
  ConciehalfIcon,
  ConfulenceIcon,
  ConnectIcon,
  CrossIcon,
  DashMeterIcon,
  DeleteIcon,
  DownIcon,
  EmptyIcon,
  EyeIcon,
  FacebookIcon,
  FacialMaskIcon,
  FileExplorerIcon,
  FilesIcon,
  FileuploadIcon,
  GearInArrowCircleIcon,
  GoogleIcon,
  GoogledriveIcon,
  HomeIcon,
  Icon1Icon,
  Icon2Icon,
  Icon3Icon,
  Icon4Icon,
  InboxIcon,
  InstagramIcon,
  IntegrationIcon,
  InteractionIcon,
  LearningIcon,
  LimitIcon,
  LinkedinIcon,
  LoginImgIcon,
  LogoIcon,
  MacosIcon,
  MailIcon,
  MicIcon,
  MoreVerticalIcon,
  MoveDownIcon,
  NotificationIcon,
  NotionIcon,
  OnedriveIcon,
  PinterestIcon,
  RecordingIcon,
  RedCrossIcon,
  ReportIcon,
  RolesIcon,
  SalesforceIcon,
  ScenariosIcon,
  SendIcon,
  SettingIcon,
  SideBarHomeIcon,
  SignoutIcon,
  SocialIcon,
  SourceIcon,
  TaskIcon,
  TempsignupimgIcon,
  TripleDotIcon,
  TopRightArrowIcon,
  TextIcon,
  TrainingIcon,
  TwitterIcon,
  UploadIcon,
  UserIcon,
  UserStarIcon,
  VoiceIcon,
  WebIcon,
  WavesIcon,
  WebsiteIcon,
  WorkspacedownIcon,
  ViewPaper,
  FontIcon,
  TxtIcon,
  PdfIcon,
  ParallelArrowsIcon,
  WordIcon,
  ContactIcon,
  FoldedPaper,
  GlobeIcon,
  HappyFaceIcon,
  SadFaceIcon,
  NeutralFaceIcon,
  ThumbsUpIcon,
  ThumbsDownIcon,
  FilledThumbsUpIcon,
  FilledThumbsDownIcon,
  CompassIcon,
  CopyWhiteIcon,
  GreenContactIcon,
  CheckForm,
  CopyIcon,
  PurpleMessage,
  BlueMessage,
  OrangeMessage,
  GreenMessage,
  InvertCopyIcon,
  MessageIcon,
  AdvancedIcon,
  ThreadsIcon,
  WixLogoIcon,
  ShopifyLogo,
  FramerLogo,
  WordPressLogo,
  WebflowIcon,
  ContactFormIcon,
  BookingIcon,
  CallIcon,
  CartIcon,
  ConsentIcon,
  DiscountIcon,
  InternetIcon,
  OrderIcon,
  QuoteIcon,
  ReviewIcon,
  SupportIcon,
  Alien,
  SendArrow,
  ShopifyIcon,
  OutlookIcon,
  HubspotIcon,
  CalendlyIcon,
  WixIcon,
  ZendeskIcon,
  ApolloIcon,
  ZapierIcon,
  WooCommerceIcon,
  FreshdeskIcon,
  GoogleTagManagerIcon,
  ArrowIcon,
  TVIcon,
  RoundContactIcon,
  ChannelWebsiteIcon,
  SharedIcon,
  MultiUserIcon,
  MessageIconWhite,
  NutBotlIcon,
  StatsIcon,
  PromptIcon,
  ShieldIcon,
  MapIcon,
  Bookings,
  OutlookCalendarIcon,
  SocialLikeIcon,
  Search,
  BookIcon,
  AssetsIcon,
  TeamsIcon,
  HumanIcon,
  AppointmentIcon,
  RequestIcon,
  FacebookActivity,
  InstagramActivity,
  StandAloneActivity,
  WhatsappActivity,
  AssetImage,
  AssetPdf,
  AssetVideo,
  AssetList,
  AssetMap,
  AssetUrl,
  GoogleCalendar,
  OutlookCalendar,
  BellIcon,
  ShowAssets,
  AssetPreview,
  Addlink,
  Frame,
  Role,
  SettingTwoIcon,
  LimitationsIcon,
  UserRulesIcon,
  DragIcon,
  ConcieBlackIcon,
  UpArrow,
  Microphone,
  OnboardingAvatar,
  StarsIcon
};
